import { useContext } from 'react';
import { LocaleContext } from '@contexts/LocaleContext';
import type { LocaleContextType } from '@/types';

export const useLocale = (): LocaleContextType => {
  const context = useContext(LocaleContext);

  if (!context) {
    throw new Error('useLocale must be used within a LocaleProvider');
  }

  return context;
};
